






































































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
/* 画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { masterCodeModule } from '../store/modules/MasterCode'; // ストアモジュール
import { KanriConstants } from '../fixed/KanriConstants';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class MasterCodeInfo extends ApiAccessBase {

  // 画面初期化処理
  // component生成時に実行
  private created() {
    let path = '';
    if (masterCodeModule.CHECK_MOVE_STATE) {
      // 編集時
      path = KanriConstants.CODE_PATH + masterCodeModule.GET_PATH;
      masterCodeModule.arrivalToInfo();
    } else {
      // 新規登録時
      path = KanriConstants.CODE_PATH + '/init';
    }
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['masterCodeTable_info']);
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
        }
      },
    );
  }

  /**
   * コード表登録
   * (登録ボタン押下時に発火)
   */
  private registCodeTable() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      const errorBag: any = this.getFormErrorData(this.$refs.form);
      for (const error of Object.keys(errorBag)) {
        if (errorBag[error]) {
          if (!this.focusElement('input-' + error) ) {
            // ラジオボタン用(エラーidのオブジェクトがdivになっておりradioは+1)
            this.focusElement('input-' + (Number(error) + 1));
          }
          break;
        }
      }
      return;
    }
    // ＜関連チェックをいれるならここ＞
    if (window.confirm(Message.I0003)) {
      this.apiAccess(
        KanriConstants.CODE_PATH,
        Constants.API_METHOD_POST,
        true,
        true,
      ).then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          // 成功
          alert(Message.I0004);
        } else {
          // 失敗
          alert(Message.E0000);
        }
      });
    }
  }
}
